import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import SignUp from './SignUp';
import Signin from './SignIn';
import StudentTypeSelection from './StudentTypeSelection';
import Dashboard2 from './Dashboard2';

import AdminDasboard from './Admin/AdminDasboard';
import UploadRecordings from './Admin/UploadRecordings';
import AdminDashboardGuest from './Admin/AdminDashboardGuest';
import UploadMarks from './Admin/UploadMarks';
import UploadDocument from './Admin/UploadDocuments';
import StudentApprovals from './Admin/StudentApprovals';
import ApprovedStudents from './Admin/ApprovedStudents';
import PendingApproval from './PendingApproval';

import WatchVideosFolder from './WatchVideosFolder';
import MarkSheets from './MarkSheets';

// Guest Pages
import GuestDashboard from './GuestPages/GuestDashboard';
import Essays from './GuestPages/Essays';
import Seminar from './GuestPages/Seminar';
import Quiz from './GuestPages/Quiz';
import PastPapers from './GuestPages/PastPapers';
import ModelPapers from './GuestPages/ModelPapers';
import ProvincialPapers from './GuestPages/ProvincialPapers';
import Home from './home';


import January from './Recordings/January';
import February from './Recordings/February';
import March from './Recordings/March';

// Marks by Month
import JulyMarks from './Marks/JulyMarks';
import AugustMarks from './Marks/AugustMarks';
import JuneMarks from './Marks/JuneMarks';

import Tutes from './Tutes';
import ForgotPassword from './ForgotPassword';
import PrivateRoute from './RequirAuth';
import AdminRoute from './AdminRoute';

// Grade 9
import Dashboard9 from './ADDITIONAL/Grade 9/Dashboard9';
import Marks9 from './ADDITIONAL/Grade 9/Marks9';
import Notes9 from './ADDITIONAL/Grade 9/Notes9';
import Grade9March from './ADDITIONAL/Grade 9/Grade9March';
import Grade9Recordings from './ADDITIONAL/Grade 9/Grade9Recordings';
import Grade9MonthPage from './ADDITIONAL/Grade 9/Grade9MonthPage';

// Spoken English programme
import SpokenDashboard from './Spoken/SpokenDashboard';
import AdminSpokenDashboard from './Spoken/AdminSpokenDashboard';
import VerifyCertificate from './VerifyCertificate';


import May from './Recordings/May';
import June from './Recordings/June';
import July from './Recordings/July';
import August from './Recordings/August';
import September from './Recordings/September';
import October from './Recordings/October';

function App() {
  return (
    <Router>
      <Helmet>
        <title>The BEE Academy</title>
      </Helmet>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Signup" element={<SignUp />} />
        <Route path="/Signin" element={<Signin />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/GuestDashboard" element={<GuestDashboard />} />
        <Route path="/Home" element={<Home />} />
        <Route path="/StudentTypeSelection" element={<StudentTypeSelection />} />
        <Route path="/verify/:certId" element={<VerifyCertificate />} />

        {/* Protected Student Routes */}
        <Route path="/Dashboard2" element={<PrivateRoute element={<Dashboard2 />} />} />
        <Route path="/Essays" element={<PrivateRoute element={<Essays />} />} />
        <Route path="/Seminar" element={<PrivateRoute element={<Seminar />} />} />
        <Route path="/WatchVideosFolder" element={<PrivateRoute element={<WatchVideosFolder />} />} />
        <Route path="/MarkSheets" element={<PrivateRoute element={<MarkSheets />} />} />
        <Route path="/PastPapers" element={<PrivateRoute element={<PastPapers />} />} />
        <Route path="/ModelPapers" element={<PrivateRoute element={<ModelPapers />} />} />
        <Route path="/ProvincialPapers" element={<PrivateRoute element={<ProvincialPapers />} />} />
        <Route path="/Quiz" element={<PrivateRoute element={<Quiz />} />} />
        <Route path="/docs/tutes" element={<PrivateRoute element={<Tutes />} />} />

        {/* Recordings by Month */}
       
        <Route path="/January" element={<PrivateRoute element={<January />} />} />
        <Route path="/February" element={<PrivateRoute element={<February />} />} />
        <Route path="/March" element={<PrivateRoute element={<March />} />} />


        {/* Marks by Month */}
        <Route path="/marks/july" element={<PrivateRoute element={<JulyMarks />} />} />
        <Route path="/marks/august" element={<PrivateRoute element={<AugustMarks />} />} />
        <Route path="/marks/june" element={<PrivateRoute element={<JuneMarks />} />} />


        {/* Grade 9 Routes */}
        <Route path="/Grade9/Dashboard" element={<PrivateRoute element={<Dashboard9 />} />} />
        <Route path="/Grade9/Marks" element={<PrivateRoute element={<Marks9 />} />} />
        <Route path="/Grade9/Notes" element={<PrivateRoute element={<Notes9 />} />} />
        <Route path="/Grade9/March" element={<PrivateRoute element={<Grade9March />} />} />
        <Route path="/Grade9/Recordings" element={<PrivateRoute element={<Grade9Recordings />} />} />
        <Route path="/Grade9/Recordings/:month" element={<PrivateRoute element={<Grade9MonthPage />} />} />

        <Route path="/May" element={<PrivateRoute element={<May />} />} />
        <Route path="/June" element={<PrivateRoute element={<June />} />} />
        <Route path="/July" element={<PrivateRoute element={<July />} />} />
        <Route path="/August" element={<PrivateRoute element={<August />} />} />
        <Route path="/September" element={<PrivateRoute element={<September />} />} />
        <Route path="/October" element={<PrivateRoute element={<October />} />} />

        {/* Spoken English Routes (Student IDs like SP2601001) */}
        <Route path="/Spoken/Dashboard" element={<PrivateRoute program="spoken" element={<SpokenDashboard />} />} />

        {/* Admin Routes */}
        <Route path="/AdminSpokenDashboard" element={<AdminRoute element={<AdminSpokenDashboard />} />} />
        <Route path="/AdminDashboard" element={<AdminRoute element={<AdminDasboard />} />} />
        <Route path="/AdminDashboardGuest" element={<AdminRoute element={<AdminDashboardGuest />} />} />
        <Route path="/StudentApprovals" element={<AdminRoute element={<StudentApprovals />} />} />
        <Route path="/ApprovedStudents" element={<AdminRoute element={<ApprovedStudents />} />} />
        <Route path="/UploadRecordings" element={<AdminRoute element={<UploadRecordings />} />} />
        <Route path="/UploadMarks" element={<AdminRoute element={<UploadMarks />} />} />
        <Route path="/UploadDocuments" element={<AdminRoute element={<UploadDocument />} />} />
        <Route path="/pending-approval" element={<PendingApproval />} />
      </Routes>
    </Router>
  );
}

export default App;
